<template>
    <detalhe titulo="Objeto" :size="size">
        <vue-json-pretty :data="JSON.parse(lead?.objetoIntegracaoPj)" :showDoubleQuotes="true" v-if="lead?.objetoIntegracaoPj?.isJson()"></vue-json-pretty>
        <span v-if="!lead?.objetoIntegracaoPj?.isJson()">{{ lead?.objetoIntegracaoPj }}</span>
    </detalhe>
    <detalhe titulo="Retorno" :size="size">
        <vue-json-pretty :data="JSON.parse(lead?.retornoIntegracaoPj)" :showDoubleQuotes="true" v-if="lead?.retornoIntegracaoPj?.isJson()"></vue-json-pretty>
        <span v-if="!lead?.retornoIntegracaoPj?.isJson()">{{ lead?.retornoIntegracaoPj }}</span>
    </detalhe>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
    props: {
        lead: {
            type: Object,
        },
    },

    data() {
        return {
            size: '100',
        };
    },

    components: {
        VueJsonPretty,
    },
};
</script>